module.exports = __webpack_public_path__ + "img/6手机.792e7661.png";